import type { IdeationType } from '../../../shared/types';

// All ideation types for iteration
// Note: high_value_features removed - strategic features belong to Roadmap
export const ALL_IDEATION_TYPES: IdeationType[] = [
  'code_improvements',
  'ui_ux_improvements',
  'documentation_gaps',
  'security_hardening',
  'performance_optimizations',
  'code_quality'
];
